import React, { Component } from 'react';
import { Tab } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as settlementAction from 'actions/settlement';
import * as etcAction from 'actions/etc';
import storage from 'helpers/storage';
import Trading from 'components/SettlementList/SidePage/Trading';
import TaxInvoice from 'components/SettlementList/SidePage/TaxInvoice';
import BankDeposit from 'components/SettlementList/SidePage/BankDeposit';
import SettlementMetaInfo from 'components/SettlementList/SidePage/SettlementMetaInfo';

class SideMenu extends Component {
  componentDidMount() {
    this.getAuthStaffDet();
  }
  // 거래명세서 정보
  tradingInfo = async () => {
    const { settlementAPI } = this.props;
    const { taxUnitSeq } = this.props.subMenuData.match.params;

    await settlementAPI.settlementTrading(taxUnitSeq);
  };

  // 고객사 메타정보
  companyMetaInfo = async () => {
    const { settlementAPI } = this.props;
    const { companyId } = this.props.subMenuData.match.params;

    await settlementAPI.settlementMetaInfo(companyId);
  };

  // 세금계산서 정보
  taxInvoice = async () => {
    const { settlementAPI } = this.props;
    const { taxUnitSeq } = this.props.subMenuData.match.params;

    await settlementAPI.settlementTaxInvoice(taxUnitSeq);
  };

  // 은행입금 정보
  bankDeposit = async () => {
    const { settlementAPI } = this.props;
    const { taxUnitSeq } = this.props.subMenuData.match.params;

    await settlementAPI.settlementBankDeposit(taxUnitSeq);
  };

  // 진행상태
  progressStatus = async () => {
    const { settlementAPI } = this.props;
    const { taxUnitSeq } = this.props.subMenuData.match.params;

    await settlementAPI.settlementProgressStatus(taxUnitSeq);
  };

  getAuthStaffDet = async () => {
    const { etcAPI } = this.props;
    const company = storage.get('company');

    if (company.user.id) {
      await etcAPI.authStaffDet({ id: company.user.id });
    }
  };

  settlementDetailClick = async (e, name) => {
    const { activeIndex } = name;

    this.progressStatus();

    if (activeIndex === 0) {
      // 거래명세서
      this.tradingInfo();
    } else if (activeIndex === 1) {
      // 세금계산서
      this.taxInvoice();
    } else if (activeIndex === 2) {
      // 은행입금 목록
      this.bankDeposit();
    } else if (activeIndex === 3) {
      // 세부정보
      this.companyMetaInfo();
    }
  };

  render() {
    const { subMenuData, defaultActiveIndex } = this.props;
    const { companyId, taxUnitSeq } = this.props.subMenuData.match.params;

    return (
      <main>
        {subMenuData && defaultActiveIndex != null && (
          <Tab
            menu={{ fluid: true, vertical: true }}
            border="1"
            grid={{ paneWidth: 14, tabWidth: 2 }}
            menuposition="right"
            defaultActiveIndex={defaultActiveIndex}
            onTabChange={this.settlementDetailClick}
            panes={[
              { menuItem: '거래명세서', render: () => <Trading companyId={companyId} taxUnitSeq={taxUnitSeq} /> },
              { menuItem: '세금계산서', render: () => <TaxInvoice /> },
              {
                menuItem: '은행입금 목록',
                render: () => <BankDeposit companyId={companyId} taxUnitSeq={taxUnitSeq} />
              },
              { menuItem: '세부정보', render: () => <SettlementMetaInfo /> }
            ]}
          />
        )}
      </main>
    );
  }
}

SideMenu = connect(
  (state) => ({
    state
  }),
  (dispatch) => ({
    settlementAPI: bindActionCreators(
      {
        settlementTrading: settlementAction.SettlementTradingInfoDetail,
        settlementMetaInfo: settlementAction.SettlementMetaInfoDetail,
        settlementTaxInvoice: settlementAction.SettlementTaxInvoice,
        settlementBankDeposit: settlementAction.SettlementBankDeposit,
        settlementProgressStatus: settlementAction.SettlementProgressStatus
      },
      dispatch
    ),
    etcAPI: bindActionCreators(
      {
        authStaffDet: etcAction.AuthStaffDet
      },
      dispatch
    )
  })
)(SideMenu);

export default SideMenu;
